// Reemplazar este link por el link real de checkout (MercadoPago, Hotmart, etc.)
// Opción 1: El Arsenal del Nutri base ($19.990)
export const CHECKOUT_URL =
  'https://nutri.librosdigitales.pro/cart/47047564722364:1'

// Opción 2: El Arsenal del Nutri + 3 Especializaciones ($29.990)
export const CHECKOUT_URL_PLUS =
  'https://nutri.librosdigitales.pro/cart/46929088250044:1'

export const scrollToBuy = (e?: React.MouseEvent) => {
  if (e) e.preventDefault()
  // Cada vez que un CTA lleva a la sección de pagos, dejamos seleccionada
  // la opción "Arsenal + 3 Especializaciones".
  window.dispatchEvent(new CustomEvent('select-plus-plan'))
  const element = document.getElementById('comprar')
  if (element) {
    element.scrollIntoView({ behavior: 'smooth' })
  }
}

// Solo dispara el evento del Meta Pixel. IMPORTANTE: no hacemos preventDefault
// ni window.open acá, para no interferir con la navegación nativa del <a>.
// El enlace navega con su href normal (target="_top" para escapar del iframe),
// que es lo que funciona de forma confiable en el sitio publicado.
export const trackCheckout = () => {
  if (typeof window !== 'undefined' && (window as any).fbq) {
    ;(window as any).fbq('track', 'InitiateCheckout')
  }
}
